import React, { useMemo } from "react";

import { BarAndPieChart, BarAndPieChartData } from "../../../Components/Charts/BarAndPieChart/BarAndPieChart";
import { ChartProps, processTable } from "./CallToActionChart";

export const DiscountChart: React.FC<ChartProps> = ({ data }) => {
  let transformedData = processTable(data);
  transformedData = transformedData.filter((item) => item.title !== "Intent");
  return (
    <>
      <BarAndPieChart data={transformedData} showTotals={true} height={400} width={600} />
      <pre>{JSON.stringify(transformedData, null, 2)}</pre>
    </>
  );
};
